import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { InternshipJobApplicationRecord } from "@/client/services/internship-jobs";

type AppliedJobsTableProps = {
  loading?: boolean;
  records: InternshipJobApplicationRecord[];
  emptyMessage?: string;
};

const formatDate = (value?: string) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

const feedbackLabel = (feedback?: "applied" | "not_applied") => {
  if (feedback === "applied") return "Applied";
  if (feedback === "not_applied") return "Not Applied";
  return "Pending";
};

export const AppliedJobsTable = ({
  loading = false,
  records,
  emptyMessage = "No applied job records found.",
}: AppliedJobsTableProps) => {
  if (loading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (records.length === 0) {
    return (
      <Box sx={{ py: 6 }}>
        <Typography sx={{ color: "text.secondary" }}>{emptyMessage}</Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        height: "80vh",
        overflowY: "auto",
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            {["Job Title", "Company", "Location", "Feedback", "Opened At", "Applied At"].map((col) => (
              <TableCell
                key={col}
                sx={{
                  backgroundColor: "#dde8fb",
                  color: "#1976d2",
                  fontWeight: 700,
                  fontSize: "13px",
                  borderBottom: "2px solid #90caf9",
                }}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record) => (
            <TableRow
              key={`${record.studentId}-${record.jobUniqueId}`}
            >
              <TableCell>{record.jobTitle}</TableCell>
              <TableCell>{record.company}</TableCell>
              <TableCell>{record.location || "-"}</TableCell>
              <TableCell>{feedbackLabel(record.feedback)}</TableCell>
              <TableCell>{formatDate(record.applicationOpenedAt)}</TableCell>
              <TableCell>{formatDate(record.appliedAt)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};